export const SHOW_PROJECT_BUILDER_QUERY_PARAM = 'showProjectBuilder';
export const SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV = 'showProjectBuilderDev';

export const BLANK_PROJECT_TEMPLATES = [
	'com.atlassian.servicedesk:simplified-blank-project-it',
	'com.atlassian.servicedesk:simplified-blank-project-business',
	'com.atlassian.servicedesk:company-managed-blank-service-project',
	'com.atlassian.servicedesk:team-managed-blank-service-project',
];
